export type AnalyticsPayload = Record<string, unknown>;

const getAttribution = () => {
  if (typeof window === "undefined") {
    return {};
  }

  const storageKey = "vonxai_initial_attribution";

  try {
    const stored = window.sessionStorage.getItem(storageKey);
    if (stored) {
      return JSON.parse(stored);
    }

    const params = new URLSearchParams(window.location.search);
    const attribution = {
      landing_page: `${window.location.pathname}${window.location.search}`,
      initial_referrer: document.referrer || undefined,
      utm_source: params.get("utm_source") || undefined,
      utm_medium: params.get("utm_medium") || undefined,
      utm_campaign: params.get("utm_campaign") || undefined,
      utm_content: params.get("utm_content") || undefined,
      utm_term: params.get("utm_term") || undefined,
    };

    window.sessionStorage.setItem(storageKey, JSON.stringify(attribution));
    return attribution;
  } catch {
    return {};
  }
};

export const trackEvent = (
  eventName: string,
  payload: AnalyticsPayload = {},
) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    app_name: "vonxai.co.jp",
    ...getAttribution(),
    ...payload,
  });
};
